import React from 'react';
import {DI} from 'modules';

const LiveNotes = ({common: {strings}, notes}) => {
  if (typeof notes !== 'string') return null;
  return (
    <div className='live-notes'>
      <span className='live-notes__label'>
          {strings['page.lives.view.notes.title']}
      </span>
      <span className='live-notes__value'>
        {notes.split(/\n/g).map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </span>
    </div>
  );
};

export default DI()(LiveNotes);
